import React, { FC, ChangeEvent } from 'react'
import { TextField } from 'transfix-ui/components/TextField'
import Typography from 'transfix-ui/core/Typography'
import makeStyles from 'transfix-ui/core/styles/makeStyles'
import { brandColors } from 'transfix-ui/theme'

interface IMatrixInput {
  value: string
  type?: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  isValid?: boolean
  placeholder?: string
  dataTest?: string
}

interface IInputMatrixProps {
  rows: string[]
  columns: string[]
  matrix: IMatrixInput[][]
  defaultInputType?: string
  endAdornment?: string
  description?: string
}

const useStyles = makeStyles(theme => ({
  table: {
    boxShadow: 'none',
  },
  tableRow: {
    borderBottom: `1px solid ${brandColors.coolGray3}`,
  },
  tableCell: {
    padding: theme.spacing(1),
  },
}))

export const InputMatrix: FC<IInputMatrixProps> = ({
  columns,
  defaultInputType = 'text',
  description,
  endAdornment = '',
  matrix,
  rows,
}) => {
  const classes = useStyles()
  const displayColumns: string[] = ['', ...columns]

  return (
    <div>
      <table className={classes.table}>
        <tr className={classes.tableRow}>
          {displayColumns.map(columnName => (
            <td key={columnName} className={classes.tableCell}>
              {columnName}
            </td>
          ))}
        </tr>
        {rows.map((row, rowIdx) => (
          <tr key={row} className={classes.tableRow}>
            <td className={classes.tableCell}>{row}</td>
            {matrix[rowIdx] &&
              matrix[rowIdx].slice(0, row.length).map(rowObj => (
                <td
                  key={rowObj.placeholder}
                  aria-label={rowObj.placeholder}
                  className={classes.tableCell}>
                  <TextField
                    type={rowObj.type || defaultInputType}
                    value={rowObj.value}
                    placeholder={rowObj.placeholder}
                    onChange={rowObj.onChange}
                    dataTest={rowObj.dataTest}
                    error={!rowObj.isValid}
                    InputProps={{
                      endAdornment,
                    }}
                  />
                </td>
              ))}
          </tr>
        ))}
      </table>
      {description && (
        <Typography className='mt2' variant='subtitle1' color='textSecondary'>
          {description}
        </Typography>
      )}
    </div>
  )
}
